"use client";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useProductTileClickProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/ProductTileClickProvider/ProductTileClickContext";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import React, { ReactNode } from "react";

interface IInsiderLinkClientWrapperProps {
  brandToken: string | undefined;
  productUrl?: string;
  selectedProductOptionToken?: string;
  dataTestId?: string;
  children: ReactNode;
}

export const InsiderLinkClientWrapper: React.FC<
  IInsiderLinkClientWrapperProps
> = ({ dataTestId, children }) => {
  const { productLinkProps, onProductClick } = useProductTileClickProps();

  return (
    <Link
      onClick={onProductClick}
      data-test-id={dataTestId}
      to={productLinkProps?.productUrl ?? ""}
      replace={productLinkProps?.replace}
    >
      {children}
    </Link>
  );
};
